
import React from 'react';
import { Box, Slide,useMediaQuery } from '@mui/material';

export class StartCourseSharedData {
    static slideTo = 'left';

    static getSlideTo() {
        return this.slideTo;
    }

    static setSlideTo(val) {
        this.slideTo = val;
    }
}

export const DescriptionBlock = ({ htmlContent, bgImgUrl, fontSize, marginX, marginY }) => {
    const hasImage = Boolean(bgImgUrl); // Check if an image URL is provided

    // Responsive margin logic // if you want set only for mobile not for tablet use xs
    const isSmallDevice = useMediaQuery((theme) => theme.breakpoints.down("sm")); 
    const isLargeDevice = useMediaQuery((theme) => theme.breakpoints.up("lg"));

    const responsiveMarginX = isSmallDevice ? 2 : marginX || 15;
    const responsiveMarginY = {
        top: isSmallDevice ? 3 : marginY?.top || 10,
        bottom: isSmallDevice ? 3 : marginY?.bottom || 3,
    };

    return (
        <>
        <Box
            component="div"
            fontSize={fontSize || "12px"}
            mx={responsiveMarginX}
            mt={responsiveMarginY.top}
            mb={responsiveMarginY.bottom}
            padding={bgImgUrl ? '10px' : '0px'}            
            dangerouslySetInnerHTML={{ __html: htmlContent }}
            sx={{
                position: "relative", // Ensures the content and overlay are positioned correctly
                overflow: "hidden",  // Prevents content from overflowing
                zIndex: 0,           // Keeps the background in the back
            }}

            // sx={{
            //     backgroundImage: hasImage ? `url(${bgImgUrl})` : "none",
            //     backgroundSize: hasImage ? "cover" : "initial",
            //     backgroundRepeat: "no-repeat",
            //     backgroundPosition: "center",
            //     display: "flex", // Enable flexbox for alignment
            //     alignItems: "center", // Vertically centers the block itself
            //     justifyContent: "center", // Horizontally centers the block itself
            //     // height: hasImage ? "600px" : "200px", // Adjust height dynamically
            //     textAlign: "flex-start", // Center text for better visual balance
            //     // marginTop: hasImage ? "2px" : "8%",
            //     // backgroundColor: hasImage ? "transparent" : "#f5f5f5", // Add a background color for no image case
            //     // border: hasImage ? "none" : "1px solid #ccc", // Optional border when no image
            //}}
        />
        {/* Background Layer */}
    {bgImgUrl && (
        <Box
            sx={{
                backgroundImage: `url(${bgImgUrl})`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                opacity: 0.5, // Set the background image opacity
                zIndex: -1,  // Ensures it stays behind the content
            }}
        />
    )}
    </>
    );
};

export const SlidingBlock = ({ children, currentStep }) => {
    const slideTo = StartCourseSharedData.getSlideTo()

    return (
        <Slide
            in={true}
            direction={slideTo}
            timeout={800}
            mountOnEnter
            unmountOnExit
            key={currentStep} // Key is important to trigger the slide animation
            appear={false} // Prevent initial animation measurement issues
        >
            <Box
                sx={{
                    width: '100%',
                    height: '100%',
                    display: 'block',
                }}
            >
                {children}
            </Box>
        </Slide>
    )
}


// import { useState } from 'react';
// import { Rnd } from 'react-rnd';
// import { isHtmlContentEmpty } from '../../utils/html.utils';
// import LaunchRoundedIcon from '@mui/icons-material/LaunchRounded';
// import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
// const MinimizedBlockContainer = styled(Box)({
//     position: 'fixed',
//     bottom: '0px',
//     right: '20px',
//     width: '120px',
//     height: '60px',
//     backgroundColor: 'rgba(0,0,0,0.8)',
//     borderRadius: '2px',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     cursor: 'pointer',
//     color: 'white'
// });

// const FloatingBlockStyle = {
//     backgroundColor: 'rgba(0,0,0,0.8)',
//     padding: '5px 20px 20px 20px',
//     borderRadius: '8px',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     overflow: "hidden",
//     flexDirection: "column",
//     position: 'fixed', // Keep the block fixed to the viewport
//     top: "15%", // Adjust this to where you'd like it to stick
//     left: "unset",
//     right: "10%", // Adjust the initial position
// }

// export const DescriptionBlock = ({ htmlContent }) => {
//     const [isMinimized, setIsMinimized] = useState(false);

//     const toggleMinimize = () => {
//         setIsMinimized(!isMinimized);
//     };

//     if (isHtmlContentEmpty(htmlContent)) return <></>

//     if (isMinimized) {
//         return (
//             <Tooltip title="Restore description">
//                 <MinimizedBlockContainer onClick={toggleMinimize}>
//                     <LaunchRoundedIcon size={20} />
//                 </MinimizedBlockContainer>
//             </Tooltip>
//         )
//     }
//     else {
//         return (
//             <Rnd
//                 default={
//                     {
//                         width: 400,
//                         height: 500,
//                     }
//                 }
//                 minWidth={150}
//                 minHeight={100}
//                 bounds="window"
//                 disableDragging
//                 style={FloatingBlockStyle}
//             >
//                 <Box display="flex" alignItems="center" width="100%" py={1}>
//                     <span className='fillSpace'></span>
//                     <Tooltip title="Minimize" placement="top">
//                         <CloseRoundedIcon size={20} style={{ cursor: 'pointer', color: "white" }} onClick={toggleMinimize} />
//                     </Tooltip>
//                 </Box>
//                 <Box display="flex" flexDirection="column" height="100%" overflow="auto" color="white" flexGrow={1}>
//                     <span dangerouslySetInnerHTML={{ __html: htmlContent }}></span>
//                 </Box>
//             </Rnd>
//         );
//     }
// }


